<div [hidden]="!loading">
    <div class="loader"></div>
</div>